var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7499 1.77526L7.09964 7.42554C7.0209 7.50455 6.92733 7.56724 6.82431 7.61002C6.72129 7.6528 6.61084 7.67482 6.49929 7.67482C6.38774 7.67482 6.27729 7.6528 6.17427 7.61002C6.07125 7.56724 5.97769 7.50455 5.89895 7.42554L0.24867 1.77526C0.0894494 1.61604 -2.37257e-09 1.40009 0 1.17491C2.37257e-09 0.949742 0.0894494 0.733792 0.24867 0.574572C0.407891 0.415351 0.62384 0.325902 0.849012 0.325902C1.07418 0.325902 1.29013 0.415351 1.44935 0.574572L6.5 5.62522L11.5506 0.573866C11.7099 0.414645 11.9258 0.325195 12.151 0.325195C12.3762 0.325195 12.5921 0.414645 12.7513 0.573866C12.9105 0.733086 13 0.949036 13 1.17421C13 1.39938 12.9105 1.61533 12.7513 1.77455L12.7499 1.77526Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).43382e7bf014956628921f67841ff8a7.svg";
export { ForwardRef as ReactComponent };